import axios from "axios";
import {store} from '../redux/store'
import {logout} from "../redux/authSlice";
import {getIdentifierFromSubDomain, getRelevantStore} from "../../../web/src/helpers/functions";
import {projectTypeMainSlice, projectTypes} from "./constants";
import {kioskStore} from "../redux/kioskStandAlone/store";

export const axiosInstance = axios.create({
    headers: {
        'Content-Type': 'application/json',
    },
});

export const apiAction = async (apiCall, method = 'get', data = null) => {
    handleWebHeaders()
    const api = `${process.env.API_URL}${apiCall}?XDEBUG_SESSION_START=PHPSTORM`;
    const options = {
        method,
        url: api
    };
    if (data) {
        options.data = data;
    }
    console.log(api,method,data);
    return await call(options);
}

const call = async (options) => {
    try {
        const response = await axiosInstance.request(options);
        //TODO Note -> Sometimes we return structure that has data data or data
        return response.data;
    } catch (err) {
        console.log('error:' , err);
        if(!err?.response) throw err
        if (Object.prototype.hasOwnProperty.call(err.response.data, 'data')) {
            if(err.response.data.error){
                const error = err.response.data.error;
                if(error.code === 401){
                    store.dispatch(logout());
                }
            }

        }
        if (Object.prototype.hasOwnProperty.call(err.response.data, 'uniqueIdentifier')) {
            err.response.data = {
                // HERE IF SYSTEM FALLS ON UNKNOWN ERROR - RESET OBJECT TO PRINTED ONE
                statusCode: 0,
                error: {
                    message: 'unknown failure',
                    messageToUser: 'common:unknownFailure',
                    code: 0,
                },
                data: null
            };
        }
        console.log(err);
        throw err.response.data;
    }
}

const handleWebHeaders = () => {
    const headers = getWebHeadersJson();
    Object.entries(headers).forEach(([key, value]) => {
        axiosInstance.defaults.headers.common[key] = value;
    });
}

export const getWebHeadersJson = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    const relevantStore = getRelevantStore()
    const project_type = relevantStore.project?.project_type;
    const sharedData = relevantStore[projectTypeMainSlice[project_type]];

    let headers = {
        boxFk: sharedData?.box?.id,
        whiteLabel: sharedData?.whitelabel,
        newSite: 1,
        lang: (sharedData?.language?.code ?? 'en').toLowerCase(),
        version: 10,
    }

    switch(project_type) {
        case projectTypes.site:
            const site = store.getState().site;
            const identifier = getIdentifierFromSubDomain()

            headers.accessToken = store.getState()?.auth?.token
            headers.refreshToken = store.getState()?.auth?.refreshToken

            if (site.box){
                headers.identifier = site.box.external_url_id;
            } else if (identifier && !site.box) {
                headers.identifier = params.identifier;
            }
            if(site.referrer) {
                headers.refererName = site.referrer.toLowerCase();
            }
            if(site.isKiosk) {
                headers.kiosk = true
            }
            break;
        case projectTypes.kiosk:
            const kiosk = kioskStore.getState().kiosk;
            const uuid = kioskStore.getState().uuid;
            headers.refererName = 'plugin';
            headers.kioskToken = kiosk?.token;
            headers.visitorUuid = uuid?.uuid;
            break;
    }

    return headers
}